import { Web3Modal } from "@web3modal/react";
import { Route, Routes } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import { OnlyOwner } from "./components";
import { ethereumClient } from "./config/web3config";
import { Home, Market, NFT, NFTInfo, Profile, Token, Vesting } from "./pages";
import "./styles/globals.scss";

function App() {
  return (
    <main className="flex items-center justify-center">
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/lol-token" element={<OnlyOwner children={<Token />} />} />
        <Route path="/lol-nft" element={<NFT />} />
        <Route path="/lol-nft/:id" element={<NFTInfo />} />
        <Route path="/market" element={<Market />} />
        <Route path="/market/profile" element={<Profile />} />
        <Route path="/lol-vesting" element={<Vesting />} />
      </Routes>

      <ToastContainer />

      <Web3Modal
        projectId={process.env.REACT_APP_WEB3_PROJECT_ID as string}
        ethereumClient={ethereumClient}
        themeVariables={{
          "--w3m-accent-fill-color": "#000000",
        }}
      />
    </main>
  );
}

export default App;
